import { gql } from '@apollo/client'

const GET_FUNDER_ORG_COHORT = gql`
  query funderOrgCohortQuery(
    $funderEmail: String
    $funderOrgId: Int
    $nonprofitOrgIds: [Int!]!
    $returnAllNonprofitsInCohort: Boolean
  ) {
    funderOrgCohortQuery(
      funderEmail: $funderEmail
      funderOrgId: $funderOrgId
      nonprofitOrgIds: $nonprofitOrgIds
      returnAllNonprofitsInCohort: $returnAllNonprofitsInCohort
    ) {
      funderOrgId
      nonprofitOrgs {
        id
        name
      }
    }
  }
`

export default GET_FUNDER_ORG_COHORT
